// Configuración dinámica de baseURL según el entorno (Local en Laragon vs Producción)
const isLocalhost = Boolean(
    typeof window !== 'undefined' && (
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.endsWith('.test') ||
        window.location.hostname.endsWith('.local')
    )
);

const getBaseURL = () => {
    // 1. Variable de entorno personalizada si se configuró en el build
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL.replace(/\/+$/, '');
    }

    // 2. Entorno local en desarrollo con Laragon (React dev server en localhost:3000)
    if (isLocalhost) {
        return 'http://localhost/agenciasdeviajes/public';
    }

    // 3. Entorno de Producción (cPanel / Servidor Web / Hosting)
    if (typeof window !== 'undefined') {
        const origin = window.location.origin;
        const pathname = window.location.pathname;

        // Detectar si la app fue alojada en una subcarpeta (ej: https://dominio.com/agencia/...)
        const commonRoutes = [
            '/dashboard', 
            '/quienes-somos', 
            '/centros', 
            '/verificar-afiliado', 
            '/libro-reclamaciones', 
            '/politica', 
            '/login', 
            '/registro'
        ];

        for (const route of commonRoutes) {
            if (pathname.includes(route)) {
                const subPath = pathname.substring(0, pathname.indexOf(route));
                if (subPath && subPath !== '/') {
                    return (origin + subPath).replace(/\/+$/, '');
                }
            }
        }

        return origin;
    }

    return '';
};

const baseURL = getBaseURL();

export default baseURL;
